import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'quote'
})
export class QuotePipe implements PipeTransform {

  transform(value: string, args?: any): any {
    return $("<div />").html("&laquo; "+value+" &raquo;").text();
  }

}

@Pipe({name: 'plural'})
export class PluralPipe implements PipeTransform { 
  transform(number: number): string {
    return number > 1 ? 's' : ''   
  }
}



// WEBPACK FOOTER //
// ./src/app/helper/core/quote.pipe.ts